import { useEffect } from 'react'

function ImageLightbox({ image, onClose, closeLabel }) {
  useEffect(() => {
    if (!image) return undefined

    const previousOverflow = document.body.style.overflow
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [image, onClose])

  if (!image) {
    return null
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/72 px-5 py-8 backdrop-blur-sm sm:px-8 sm:py-10"
      role="dialog"
      aria-modal="true"
      aria-label={image.alt || closeLabel}
      onClick={onClose}
    >
      <div className="relative w-full max-w-6xl" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 z-20 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/55 bg-white/95 text-on-surface shadow-[0_14px_28px_rgba(0,0,0,0.18)] transition-all duration-200 hover:scale-105 hover:bg-white active:scale-95 md:right-6 md:top-6"
          aria-label={closeLabel}
        >
          <span aria-hidden="true" className="material-symbols-outlined text-[22px]" data-icon="close" />
        </button>

        <div className="overflow-hidden rounded-lg border border-white/12 bg-white/8 p-2 shadow-[0_28px_72px_rgba(0,0,0,0.24)] md:p-3">
          <img
            src={image.src}
            alt={image.alt}
            className="max-h-[80vh] w-full rounded object-contain bg-black/10"
          />
        </div>

        {(image.title || image.caption) && (
          <div className="mt-4 rounded-lg bg-black/34 px-4 py-3 text-white backdrop-blur">
            {image.title && <p className="text-base font-medium">{image.title}</p>}
            {image.caption && <p className="mt-1 text-sm text-white/78">{image.caption}</p>}
          </div>
        )}
      </div>
    </div>
  )
}

export default ImageLightbox
